export const environment = {
  production: false,
  wlType: 'defaultPortal',

  // baseUrl: 'https://esimapi.travelwings.com/api/v1/', // Live WL
  // baseUrl: 'https://sandbox.worldroambuddy.com:3006/api/v1/', // Live WL

  baseUrl: 'https://esimapi.testingtwingstech.com/api/v1/', //UAT WL BE URL

  baseUrlForSystemMandeep: 'https://api.worldroambuddy.com:3001/api/v1/', //Live SM
  // baseUrlForSystemMandeep: 'https://sandbox.worldroambuddy.com:3001/api/v1/', //Live SM
  strip_key:
    'pk_test_51KYtbwJcXrzMn7goL26p1wWAhvU1AB94KYs693qBF4hkyhppepf1yDxutknVZmX7tQSdNJyLAEXdBlVGs0ZlFVmy00qbmv8mTc',
  firebase: {
    apiKey: 'Your Api Key',
    authDomain: 'Your Auth Domain',
    databaseURL: 'Your Database Url',
    projectId: 'Your Project Id',
    storageBucket: 'Your StorageBucket url',
    messagingSenderId: 'Your Sender Id',
  }, //localhost
};
